function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { commonLocale } from "./common";
var locale = _objectSpread(_objectSpread({}, commonLocale), {}, {
  locale: 'hu_HU',
  today: 'Ma',
  // 'Today',
  now: 'Most',
  // 'Now',
  backToToday: 'Vissza a mai napra',
  // 'Back to today',
  ok: 'OK',
  clear: 'Törlés',
  // 'Clear',
  week: 'Hét',
  month: 'Hónap',
  // 'Month',
  year: 'Év',
  // 'Year',
  timeSelect: 'Időpont kiválasztása',
  // 'Select time',
  dateSelect: 'Dátum kiválasztása',
  // 'Select date',
  monthSelect: 'Hónap kiválasztása',
  // 'Choose a month',
  yearSelect: 'Év kiválasztása',
  // 'Choose a year',
  decadeSelect: 'Évtized kiválasztása',
  // 'Choose a decade',

  dayFormat: 'DD',
  // 'D',

  previousMonth: 'Előző hónap (PageUp)',
  // 'Previous month (PageUp)',
  nextMonth: 'Következő hónap (PageDown)',
  // 'Next month (PageDown)',
  previousYear: 'Múlt év (Control + left)',
  // 'Last year (Control + left)',
  nextYear: 'Jövő év (Control + right)',
  // 'Next year (Control + right)',
  previousDecade: 'Előző évtized',
  // 'Last decade',
  nextDecade: 'Következő évtized',
  // 'Next decade',
  previousCentury: 'Múlt évszázad',
  // 'Last century',
  nextCentury: 'Jövő évszázad' // 'Next century',
});
export default locale;